import _, { pick } from 'underscore';

import i18n from '../i18n';
import Organizations from '../collection/organizations';
import View from './view';

import { interval } from '../lib/handlebars.helpers';
import { getLocations } from '../ds/task.assignee.locations';
import { suggest } from '../ui/helpers/suggest';





let ifn; i18n.then( i => ifn = i );

// todo: bind into the model
export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        const { userFieldName } = options;

        // todo: cancel pgdn
        // todo: correct handle click on OK/Apply
        this.suggestionInterface_ = suggest( this.$el, `[name="${userFieldName}"]`, ($htmlInput, page, firstSearch) => {
            if (!this.model)
                return [];

            const offset = page > 0 ? page * 10 - 1 : 0,
                limit = page > 0 ? 10 : 9,
                params = {};

            if (options.nonBlockedUsersOnly)
                params.blocked = false;

            const val = this.$( `[name="${userFieldName}"]` ).val().trim(),
                user = this.model.get( this.options.userProperty ) || {},
                {name = ''} = user; 

            // filter users by name typed in form field;
            // if field contains an chosen value (i.e. value from {id, name} pair)
            // then filtering is cancelled. 
            if (!firstSearch)
                if (val !== this.options.noUserLabel )
                    params.search = val;
            //if (val && name.toLowerCase() !== val.toLowerCase())

            if (this.options.locationProperty)
                if (this.model.get( this.options.locationProperty ) ) {
                    const { lon, lat } = this.model.get( this.options.locationProperty );
                    params.lon = lon.toFixed( 5 );
                    params.lat = lat.toFixed( 5 );
                }
        
            if (options.roles)
                params.roles = options.roles;

            const req = retrieveOrganizations.call( this )
                .then( orgs => {
                    if (typeof orgs == 'function')
                        orgs = orgs();

                    const ids = orgs
                        .map( org => org.id )
                        .filter( id => !!id )
                        .join( ',' );
                    console.log( ids );

                    const pickedOrgId = this.options.organizationIdProperty &&
                        +this.model.get( this.options.organizationIdProperty );

                    if (pickedOrgId)
                        params.organizationId = pickedOrgId;
                    else if (ids)
                        params.organizationId = ids;

                    return getLocations( params, offset, limit );
                } ) ;

            const result = req.then( response => response.users )
                .then( options => options.map( option => {
                    // { user, location, distance, is_active } 
                    option.title = option.user.fio;
                    option.user.organization_id = option.user.department_id;

                    if (!option.location) return option;
                    if (!option.is_active) return option;

                    const deltaSec = Math.floor( (new Date() - option.location.date * 1000) / 1000);

                    const timeNotice = deltaSec !== undefined
                        ? interval( deltaSec )
                        : undefined;

                    if (!timeNotice) {
                        delete option.location;
                        return option;
                    }

                    option.title = `${timeNotice} — ${option.title}`;

                    if (!option.distance)
                        return option;

                    const distTitle = option.distance < 1 
                        ? `${Math.round( option.distance * 1000 ) } ${ifn( 'units::m' )}`
                        : `${option.distance.toFixed( 2 )} ${ifn( 'units::km' )}`

                    option.title = `${distTitle}, ${option.title}`;

                    return option;
                } ) )
                .then( options => { 
                    if (page !== 0) 
                        return options;

                    options.unshift( { 
                        id: 0, 
                        title: this.options.noUserLabel, 
                        user: { id: 0, fio: '' },
                    } ); 

                    return options;
                } );

            return Promise.all( [req, result] )
                .then( ([{ total }, options]) => ({ options, total, page, offset, limit }) );
        }, ($htmlInput, title, {user: {id, fio, organization_id}}) => {
            if (!this.model.get( this.options.organizationIdProperty ))
                this.model.set( this.options.organizationIdProperty, organization_id );
            this.model.set( this.options.userProperty, { id, name: fio } );
            this.trigger( 'user:choose', { id, name: fio } );
            this.trigger( 'points', [] );
            this.suggestionInterface_.hideSuggestion();
        }, $htmlInput => {
            const user = this.model.get( this.options.userProperty ) || {};
            const {name} = user;
            $htmlInput.val( name || this.options.noUserLabel );
            this.trigger( 'assignee:dropdown-hide' );
        }, (current, items) => {
            items = items.slice().map( p => (p.current = p.user.id == current.user.id, p) );
            this.trigger( 'points', items );
        } );
    },

    serialize(context) {
        const {
            userProperty,
            userFieldLabel,
            userFieldName,
            enableUserField,
            messagesForUserField,

            organizationIdProperty,
            organizationFieldLabel,
            organizationFieldName,
            enableOrganizationField,
            hideOrganizationField,
            messagesForOrganizationField,

            inline,
        } = this.options;


        return retrieveOrganizations.call( this ).then( organizations => ({
            ...context,
            organizations,
            userProperty,
            userFieldLabel,
            userFieldName, 
            enableUserField,
            messagesForUserField,

            organizationIdProperty,
            organizationFieldLabel,
            organizationFieldName,
            enableOrganizationField,
            hideOrganizationField,
            messagesForOrganizationField,

            inline,
        }) );
    },

    afterRender() {
        this.suggestionInterface_.unbindEvents();
        this.suggestionInterface_.bindEvents();
    },

    bindingHandlers: {

        getUserName: {
            set($el, user) {
                if (user)
                    $el.val( `${user.name}` || '' );
                else 
                    $el.val( this.view.options.noUserLabel );
            },
            
            get($el, value, event) {
                return {};
            }
        },

    },

} );





function retrieveOrganizations() {
    const { organizations } = this.options;
    const zeroOption = { id: 0, title: this.options.noOrganizationLabel };

    if (typeof organizations == 'function')
        return Promise.resolve( () => [zeroOption, ...organizations()] );

    if (organizations instanceof Organizations)
        return Promise.resolve( [zeroOption, ...organizations.toJSON()] );

    if (organizations)
        return Promise.resolve( [zeroOption, ...organizations] );

    return new Organizations( [] ).fetch()
        .then( ([items]) => [zeroOption, ...items] );
}



// WEBPACK FOOTER //
// ./src/js/view/user.find.js